import "./Qualities.css";

const Qualities = () => {
  return (
    <div className="qualities">
      <div className="qualities-heading">
        <h1>With Qevolt, every day is a Win day</h1>
        <h4>
          Here are some of the ways we help you maintain an outstanding business
        </h4>
      </div>
      <div className="qualities-box-flex">
        <div className="qualities-box">
          <img src="/assets/icons/repeat-circle.svg" alt="" />
          <h3>Accept transfers</h3>
          <p>
            Do you have customers who aren’t able to pay with cash or card?
            We’ve created a simple way for your business to get paid without
            delay
          </p>
        </div>
        <div className="qualities-box qualities-manage">
          <img src="/assets/icons/activity.svg" alt="" />
          <h3>Manage transfers</h3>
          <p>
            Qevolt lets you assign managers to new outlets in your organisation
            and cashiers to verify transfers on the go
          </p>
        </div>
        <div className="qualities-box">
          <img src="/assets/icons/shield-tick.svg" alt="" />
          <h3>Eliminate fraud</h3>
          <p>
            Payments made to your business reflect instantly on the Qevolt
            dashboard. This way, you’re guaranteed protection from delayed or
            fraudulent transactions
          </p>
        </div>
      </div>
    </div>
  );
};

export default Qualities;
